import { Fragment } from 'react';

/** Begrüßungen aus aller Welt – für das Laufband und die Suche. */
export const GREETINGS = [
  'Hallo',
  'Hola',
  'Bonjour',
  'Ciao',
  'Merhaba',
  'Olá',
  'Hej',
  'Cześć',
  'Salut',
  'Moin',
  'Szia',
  'Ahoj',
];

export function Marquee() {
  const group = (copy: number) => (
    <div className="marquee__group">
      {GREETINGS.map((word, index) => (
        <Fragment key={`${copy}-${word}`}>
          <span className={`marquee__word${index % 2 ? ' marquee__word--serif' : ''}`}>{word}</span>
          <span className="marquee__sep" />
        </Fragment>
      ))}
    </div>
  );
  // Zwei gleiche Gruppen: Das Band läuft um eine halbe Breite und beginnt nahtlos von vorn.
  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee__track">
        {group(1)}
        {group(2)}
      </div>
    </div>
  );
}

/** Wechselnde Begrüßung, während wir jemanden suchen. Das erste Wort steht am Ende noch einmal. */
export function RotatingGreeting() {
  const words = [...GREETINGS.slice(0, 8), 'Hallo'];
  return (
    <p className="greeting" aria-hidden="true">
      <span className="greeting__track">
        {words.map((word, index) => (
          <span key={`${word}-${index}`}>{word}</span>
        ))}
      </span>
    </p>
  );
}

/** Die Szene auf der Startseite: zwei Videobilder, die gerade zueinanderfinden. */
export function HeroVisual() {
  return (
    <div className="hero-visual" aria-hidden="true">
      <div className="hero-visual__scene">
        <figure className="mock mock--them">
          <span className="mock__light" />
          <span className="mock__person" />
          <span className="mock__live">Live</span>
          <figcaption>Jemand Neues</figcaption>
        </figure>
        <figure className="mock mock--you">
          <span className="mock__light" />
          <span className="mock__person" />
          <figcaption>Du</figcaption>
        </figure>
        <p className="mock-bubble mock-bubble--them">Hey, woher kommst du?</p>
        <p className="mock-bubble mock-bubble--you">Aus Lissabon. Und du?</p>
        <span className="signal-chip">Verbunden</span>
      </div>
    </div>
  );
}
